export const defaultFormDataState = {
    title: '',
    subtitle: '',
    author: '',
    publicationDate: '',
    numberOfPages: 0,
    currentPage: 0,
    thumbnail: ''
}